import { useState } from "react";
import { toast } from "sonner";
import { FileText, Pencil, Trash2, Check, X, ExternalLink } from "lucide-react";
import { fileUrl, formatBytes } from "@/lib/adminApi";

const small = "w-full rounded-md border border-stone-200 px-2 py-1.5 text-sm focus:border-[#C5A059] focus:outline-none";

export default function DocumentRow({ d, api, cats, onChange }) {
  const [edit, setEdit] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [form, setForm] = useState({});

  const act = async (fn, msg) => {
    try {
      await fn();
      toast.success(msg);
      setEdit(false);
      onChange();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Action impossible.");
    }
  };

  return (
    <div data-testid={`document-row-${d.id}`} className="flex items-start gap-4 rounded-2xl border border-stone-200/80 bg-white p-4 shadow-sm">
      <span className="rounded-xl bg-[#C5A059]/15 p-2.5 text-[#8a6b2e]"><FileText className="h-5 w-5" /></span>
      {edit ? (
        <div className="flex-1 space-y-2">
          <input data-testid={`document-edit-title-${d.id}`} value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} maxLength={120} className={small} />
          <input data-testid={`document-edit-category-${d.id}`} list="doc-cats" value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })} maxLength={60} className={small} />
          <textarea data-testid={`document-edit-description-${d.id}`} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} maxLength={300} rows={2} className={small} />
          <div className="flex justify-end gap-2">
            <button onClick={() => setEdit(false)} aria-label="Annuler"><X className="h-4 w-4 text-stone-400" /></button>
            <button data-testid={`document-edit-save-${d.id}`} onClick={() => act(() => api.patch(`/admin/documents/${d.id}`, form), "Document mis à jour.")} aria-label="Enregistrer"><Check className="h-4 w-4 text-emerald-600" /></button>
          </div>
        </div>
      ) : (
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#C5A059]">{d.category}</p>
          <p className="truncate font-display text-base font-semibold text-stone-900">{d.title}</p>
          {d.description && <p className="text-xs text-stone-500">{d.description}</p>}
          <p className="mt-1 text-[11px] text-stone-400">PDF, {formatBytes(d.size)}</p>
        </div>
      )}
      {!edit && (
        <div className="flex shrink-0 items-center gap-2">
          <a data-testid={`document-open-${d.id}`} href={fileUrl(d.path)} target="_blank" rel="noreferrer" aria-label="Ouvrir"><ExternalLink className="h-4 w-4 text-stone-400 hover:text-[#8a6b2e]" /></a>
          <button data-testid={`document-edit-${d.id}`} onClick={() => { setForm({ title: d.title, category: d.category, description: d.description || "" }); setEdit(true); }} aria-label="Modifier"><Pencil className="h-4 w-4 text-stone-400 hover:text-[#8a6b2e]" /></button>
          {confirm ? (
            <>
              <button data-testid={`document-delete-confirm-${d.id}`} onClick={() => act(() => api.delete(`/admin/documents/${d.id}`), "Document supprimé.")} className="rounded-full bg-[#C85A32] px-3 py-1 text-xs font-semibold text-white">Supprimer</button>
              <button data-testid={`document-delete-cancel-${d.id}`} onClick={() => setConfirm(false)} className="text-xs text-stone-500">Annuler</button>
            </>
          ) : (
            <button data-testid={`document-delete-${d.id}`} onClick={() => setConfirm(true)} aria-label="Supprimer"><Trash2 className="h-4 w-4 text-stone-400 hover:text-[#C85A32]" /></button>
          )}
        </div>
      )}
    </div>
  );
}
